








import { defineComponent } from '@vue/composition-api';
import { usePhysicalExercise } from '@/bundles/VideoContent/composables/usePhysicalExercise';

import PhysicalExerciseBaseForm from './PhysicalExerciseBaseForm.vue';

export default defineComponent({
  name: 'PhysicalExerciseCreateForm',

  components: {
    PhysicalExerciseBaseForm,
  },

  emits: ['submit'],

  setup(_, { emit }) {
    const { createExercise } = usePhysicalExercise();
    const saveExercise = async (formData: any) => {
      await createExercise(formData);
      emit('submit');
    };

    return {
      saveExercise,
    };
  },
});
